import { useLayoutEffect, useState } from 'react';

const useMinSize = (sizePixels: number, panelSelector: string) => {
	const [minSize, setMinSize] = useState(1);

	useLayoutEffect(() => {
		const panelGroup: HTMLElement = document.querySelector(panelSelector) as HTMLElement;
		const resizeHandles: NodeListOf<HTMLElement> = panelGroup?.querySelectorAll('[data-panel-resize-handle-id]');
		const resizeObserver = new ResizeObserver(entries => {
			let width =
				entries.find(({ target }) => target === panelGroup)?.contentRect.width || panelGroup.offsetWidth;

			entries.forEach(entry => {
				if (entry.target !== panelGroup) width -= entry.contentRect.width;
			});

			if (width > 0) {
				setMinSize(Math.min((sizePixels / width) * 100, 100));
			}
		});
		panelGroup && resizeObserver.observe(panelGroup);
		resizeHandles?.forEach(resizeHandle => {
			resizeObserver.observe(resizeHandle);
		});

		return () => {
			panelGroup && resizeObserver.unobserve(panelGroup);
			resizeHandles?.forEach(resizeHandle => {
				resizeObserver.unobserve(resizeHandle);
			});
			resizeObserver.disconnect();
		};
	}, []);

	return minSize;
};

export default useMinSize;
